import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  standalone: false,
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  protected sanitizer = inject(DomSanitizer);

  public transform(value: string, type: 'html'): SafeHtml;
  public transform(
    value: string,
    type: 'style' | 'script' | 'url' | 'resourceUrl'
  ): string;
  public transform(value: string, type: string): SafeHtml | string {
    switch (type) {
      case 'html':
        // Rich editor content is persisted as controlled HTML and needs
        // inline styles to render faithfully in view/edit mode.
        return this.sanitizer.bypassSecurityTrustHtml(value);

      case 'style':
        // Only keep style content accepted by Angular sanitizer.
        return this.sanitizer.sanitize(SecurityContext.STYLE, value) ?? '';

      case 'script':
        // Script content is blocked unless sanitizer explicitly allows it.
        return this.sanitizer.sanitize(SecurityContext.SCRIPT, value) ?? '';

      case 'url':
        // Sanitize URLs to remove javascript: and other unsafe schemes.
        return this.sanitizer.sanitize(SecurityContext.URL, value) ?? '';

      case 'resourceUrl':
        // Resource URLs are restricted and sanitized by Angular policy.
        return (
          this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, value) ?? ''
        );

      default:
        throw new Error(`Unsupported safe type specified: ${type}`);
    }
  }
}
